import { render, staticRenderFns } from "./AccountListAddNew.vue?vue&type=template&id=745faaba&"
import script from "./AccountListAddNew.vue?vue&type=script&lang=js&"
export * from "./AccountListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./AccountListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports